import _ from 'underscore';
import $ from 'jquery';
import Cache from 'root/cache';
import Router from 'root/router';
import Util from 'root/module/util';
import UI from 'root/ui';
import Modals from 'root/modals';
import View from 'view/base';
import View_Question_Overview from 'view/chart/survey_question_overview';
import View_Project_Performance from 'view/dashboard/performance';

const date_range_options = {
    'all'       : 'All time',
    'today'     : 'Today',
    'yesterday' : 'Yesterday',
    '7_days'    : 'Last 7 days',
    '14_days'   : 'Last 14 days',
    '30_days'   : 'Last 30 days',
    '90_days'   : 'Last 90 days'
};

const page_conditions = {
    exact_url_match: 'URL exactly matches',
    url_contains: 'URL contains',
    url_start: 'URL start with',
    url_end: 'URL ends with',
    url_not: 'URL is not',
    url_contains_not: 'URL does not contain',
    url_regex: 'URL matches regex'
}

const Page_Dashboard_Survey = View.extend({
    tagName: 'main',
    className: 'xlarge',

    date_range: 'all',

    views: {
        question_overview: {},
        project_performance: {}
    },

    events: {
        'click .date-range li'               : 'onChangeTime',
        'click .survey-preview'              : 'onPreviewSurvey',
        'click .survey-edit'                 : 'onEditSurvey',
        'click .survey-activate'             : 'onActivateSurvey',
        'click .survey-deactivate'           : 'onDeactivateSurvey',
        'click .survey-schedule'             : 'onScheduleSurvey',
        'click .copy-survey-key'             : 'onCopySurveyKey'
    },

    dom_handlers: {
        onChangeTime: function(e) {
            this.date_range = $(e.currentTarget).data('val');

            // validate input because it is from DOM
            if (!date_range_options[this.date_range]) {
                this.date_range = 'all';
            }

            Cache.app.dispatcher.trigger('Overview::Date_Change', this.date_range);
            Cache.app.addUserSetting('overview_date_range', this.date_range, true);
        },

        onPreviewSurvey: function(e) {
            this.openPreviewSurvey();
        },

        onEditSurvey: function(e) {
            if (!Cache.app.isAdmin()) {
                return;
            }

            this.openSurveyDesigner();
        },

        onActivateSurvey: function() {
            var survey = Cache.survey.findWhere({project_id: Cache.default_project_id});
            Modals.activateSurvey(survey);
        },

        onDeactivateSurvey: function() {
            var survey = Cache.survey.findWhere({project_id: Cache.default_project_id});
            Modals.deactivateSurvey(survey);
        },

        onScheduleSurvey: function() {
            var survey = Cache.survey.findWhere({project_id: Cache.default_project_id});
            Modals.cancelSurveySchedule(survey.id);
        },

        onCopySurveyKey: function() {
            var survey = Cache.survey.findWhere({project_id: Cache.default_project_id});
            Util.copyText(survey.get('survey_key'), () => {
                UI.success('Survey ID copied!');
            });
        }
    },

    event_handlers: {
        onSurveyChange: function() {
            this.renderSurveyInfo();
        }
    },

    initialize: function() {
        this.date_range = Cache.app.getUserSetting('overview_date_range', true) || 'all';

        this.views.project_performance = new View_Project_Performance({
            model: Cache.getDefaultProject(),
            mode: 'dashboard'
        });

        Cache.survey_question.each((model) => {
            if (['welcome', 'thankyou'].indexOf(model.get('question_type')) === -1) {
                this.views.question_overview['_' + model.id] = new View_Question_Overview({
                    model: model,
                    date_frame: this.date_range
                });
            }
        });

        this.listenTo(Cache.statistics, 'change:project_count', this.renderTotalResponse);
        this.listenTo(Cache.survey, 'change', this.event_handlers.onSurveyChange.bind(this));
    },

    openSurveyDesigner: function(hide_animation = false, step = '') {
        if (window.location.pathname.indexOf('/dashboard/designer') === -1) {
            Router.navigate('/' + Cache.getDefaultProject().get('project_key') + '/dashboard/designer' + (step ? '?s=' + step : ''), {trigger: false});
        }

        Modals.openSurveyStudio(hide_animation, () => {
            Router.navigate('/' + Cache.getDefaultProject().get('project_key') + '/dashboard/', {trigger: false});
        });
    },

    openPreviewSurvey: function() {
        this.openSurveyDesigner(false, 'demo');
    },

    onPageReady: function() {
        if (window.location.pathname.indexOf('/dashboard/designer') >= 0) {
            this.openSurveyDesigner(true);
        } else if (Router.getQueryString('get_code')) {
            Modals.getWidgetCode(true);
        } else if (Router.getQueryString('project_settings')) {
            Modals.projectSettings(Cache.default_project_id);
        }
    },

    renderSurveyInfo: function() {
        var survey_model = Cache.survey.findWhere({project_id: Cache.default_project_id});

        var question_total = _.size(this.views.question_overview);

        // audience
        var audience = 'Anyone';

        if (survey_model.get('has_segment') && survey_model.get('user_segment')) {
            var segment_names = survey_model.get('user_segment').split(',').map((segment_id) => {
                var segment = Cache.user_segment.get(segment_id);

                if (segment) {
                    return segment.escape('segment_name');
                } else {
                    return 'Deleted segment';
                }
            }).join(', ');

            var segment_length = survey_model.get('user_segment').split(',').length;
            audience = '<span class="tooltip" data-title="' + segment_names + '">' + segment_length + ' segment' + (segment_length === 1 ? '' : 's') + '</span>';
        }

        // pages
        var pages = 'All pages';

        if (survey_model.get('has_page_condition') && survey_model.get('page_condition')) {
            try {
                var data = JSON.parse(survey_model.get('page_condition'));

                if (data.conditions && data.conditions[0]) {
                    pages = '<span class="tooltip" data-title="' + ((page_conditions[data.conditions[0].type] || '') + ' ' + Util.htmlEntities(data.conditions[0].value)) + '">Specific pages</span>';
                }
            } catch(e) {
            }
        }

        // deivice
        var devices = 'All devices';

        if (survey_model.get('device_type').split(',').length < 3) {
            devices = survey_model.get('device_type') ? survey_model.get('device_type').split(',').map((device_name) => {
                return Util.cap(device_name);
            }).join(', ') : 'None';
        }

        var html =
        '<li>Segments: <span class="font-weight-semibold">' + audience + '</span></li>' +
        '<li>Pages: <span class="font-weight-semibold">' + pages + '</span></li>' +
        '<li>Devices: <span class="font-weight-semibold">' + devices + '</span></li>' +
        '<li><span class="font-weight-semibold">' + question_total + ' question' + (question_total === 1 ? '' : 's') + '</span></li>' +
        '<li>Survey ID: <span class="font-weight-semibold">' + survey_model.escape('survey_key') + '</span> <span class="copy-survey-key text-info cursor-pointer tooltip" data-title="Copy"><i class="fa-solid fa-clone"></span></i><br><a href="' + survey_model.getShareUrl() + '" class="primary text-medium" target="survey_share">' + survey_model.getShareUrl() + '</a></li>';

        this.$el.find('.survey-info').html(html);

        // schedule info
        this.$el.find('.schedule-info').html(survey_model.getScheduleText());

        // status
        this.$el.find('.survey-status').html(
            (survey_model.getStatus() === 'activated' ?
            (Cache.app.isAdmin() ?
            '<div class="button-dropdown">' +
                '<button type="button" class="status-dropdown status-dropdown-success" data-size="small">Activated</button>' +
                '<div>' +
                    '<ul class="dropdown">' +
                        '<li class="survey-deactivate">Deactivate</li>' +
                    '</ul>' +
                '</div>' +
            '</div>' :
            '<button type="button" class="status-btn status-btn-success">Activated</button>') : '') +

            (survey_model.getStatus() === 'scheduled' ?
            (Cache.app.isAdmin() ?
            '<div class="button-dropdown">' +
                '<button type="button" class="status-dropdown status-dropdown-attention" data-size="small">Scheduled</button>' +
                '<div>' +
                    '<ul class="dropdown">' +
                        '<li class="survey-schedule">Cancel Schedule</li>' +
                        '<li class="survey-deactivate">Deactivate</li>' +
                    '</ul>' +
                '</div>' +
            '</div>' :
            '<button type="button" class="status-btn status-btn-attention">Scheduled</button>') : '') +


            (survey_model.getStatus() === 'deactivated' ?
            (Cache.app.isAdmin() ?
            '<div class="button-dropdown">' +
                '<button type="button" class="status-dropdown status-dropdown-attention" data-size="small">Deactivated</button>' +
                '<div>' +
                    '<ul class="dropdown">' +
                        '<li class="survey-activate">Activate</li>' +
                    '</ul>' +
                '</div>' +
            '</div>' :
            '<button type="button" class="status-btn status-btn-attention" data-size="small">Deactivated</button>') : '')
        );
    },

    render: function() {
        var content =
        '<div class="aside-grid-medium">' +
            '<div>' +
                '<div class="region-performance box box-nopadding"></div>' +
                '<div class="date-range button-dropdown button-dropdown-left margin-bottom-16" data-update="true">' +
                    '<button type="button" class="dropdown-select">' + date_range_options[this.date_range] + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="all">All time</li>' +
                            '<li data-val="today">Today</li>' +
                            '<li data-val="yesterday">Yesterday</li>' +
                            '<li data-val="7_days">Last 7 days</li>' +
                            '<li data-val="14_days">Last 14 days</li>' +
                            '<li data-val="30_days">Last 30 days</li>' +
                            '<li data-val="90_days">Last 90 days</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
                '<div class="region-chart"></div>' +
            '</div>' +

            '<aside>' +
                '<div class="schedule-info"></div>' +
                '<div class="box-small-large">' +
                    '<h3 class="font-weight-semibold flex-start">' +
                        '<span class="margin-right-8">Survey</span>' +
                        '<div class="survey-status"></div>' +
                    '</h3>' +
                    '<div class="position-relative">' +
                        '<ul class="survey-info"></ul>' +
                        '<div class="survey-info-btn">' +
                            '<button type="button" class="survey-preview small tertiary min">Preview</button>' +
                            (Cache.app.isAdmin() ?
                            '<button type="button" class="survey-edit small tertiary min margin-left-8">Edit Survey</button>' : '') +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</aside>' +
        '</div>';

        this.$el.html(content);

        this.$('.date-range li[data-val="' + this.date_range + '"]').addClass('selected');

        this.views.project_performance.render().$el.appendTo(this.$el.find('.region-performance'));

        _.each(this.views.question_overview, (view) => {
            view.render().$el.appendTo(this.$('.region-chart'));
        });

        this.renderSurveyInfo();

        return this;
    }
});

export default Page_Dashboard_Survey;